<div class="wrapper" style="background:url('../assets/background.png');
                            background-repeat: no-repeat;
                            background-attachment: fixed;   
                            background-size: cover;
                            height: 100vh;">
  <header-component></header-component>
  <router-outlet></router-outlet>
</div>